'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index$1 = require('../../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var index = require('../../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Item_web_styles = require('../Item.web.styles.cjs');

/**
 * Subcomponent of DropdownMenu. Renders a radio item within a RadioGroup.
 *
 * @scope web
 */ const RadioItem = ({ value, children, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsxs(index.RadioItem, {
        value: value,
        css: Item_web_styles.item,
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("span", {
                css: Item_web_styles.iconContainer,
                children: /*#__PURE__*/ jsxRuntime.jsx(index.ItemIndicator, {
                    children: /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                        icon: index$1.faCheck
                    })
                })
            }),
            children
        ]
    });
};
RadioItem.displayName = "DropdownMenu.RadioItem";

exports.RadioItem = RadioItem;
//# sourceMappingURL=RadioItem.web.cjs.map
